module.exports = __webpack_public_path__ + "img/iOS-Share.8f01924c.png";